import { mutationOptions } from '@tanstack/react-query'
import { pinLiveReportingReport } from 'src/queries/liveReporting/liveReporting.network'

export const liveReportingMutations = {
  pin: () =>
    mutationOptions({
      mutationFn: pinLiveReportingReport,
    }),
}
